import { keyBy } from 'lodash';
import { v4 as uuid } from 'uuid';
import { logger } from 'services';
import { ApiFilter } from 'utils/simple-search-filter/simple-search-filter';
import { QueryCombinerType } from '../organisms/tasks/combiner';
import { FieldFilter } from '../organisms/tasks/filters';
const DEFAULT_FILTER = {
    type: QueryCombinerType.All,
    criteria: []
};
export const to_filter = (filter)=>{
    var _ref;
    var _filter_criteria_filter_filter, _filter_criteria_filter, _filter_criteria, _filter_criteria_filter1, _filter_criteria1, _filter_nestedFilter, _filter_criteria_filter_filter1, _filter_criteria_filter2, _filter_criteria2;
    const nativeFields = filter === null || filter === void 0 ? void 0 : (_filter_criteria = filter.criteria) === null || _filter_criteria === void 0 ? void 0 : (_filter_criteria_filter = _filter_criteria.filter(FieldFilter.isValid)) === null || _filter_criteria_filter === void 0 ? void 0 : (_filter_criteria_filter_filter = _filter_criteria_filter.filter((x)=>!x.field.userCreated && x.field.fieldName !== 'template')) === null || _filter_criteria_filter_filter === void 0 ? void 0 : _filter_criteria_filter_filter.map(ApiFilter.toNativeFieldFilterFormat);
    const templateField = (_filter_criteria1 = filter.criteria) === null || _filter_criteria1 === void 0 ? void 0 : (_filter_criteria_filter1 = _filter_criteria1.filter(FieldFilter.isValid)) === null || _filter_criteria_filter1 === void 0 ? void 0 : _filter_criteria_filter1.find((x)=>x.field.fieldName === 'template');
    if (templateField) {
        // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        nativeFields.push(ApiFilter.toNativeFieldFilterFormat(templateField));
    }
    const nonEmptyNestedFilters = (_ref = filter === null || filter === void 0 ? void 0 : (_filter_nestedFilter = filter.nestedFilter) === null || _filter_nestedFilter === void 0 ? void 0 : _filter_nestedFilter.filter((nestedFilter)=>{
        var _ref;
        var _nestedFilter_criteria, _nestedFilter_nestedFilter;
        const hasValidCriteria = nestedFilter === null || nestedFilter === void 0 ? void 0 : (_nestedFilter_criteria = nestedFilter.criteria) === null || _nestedFilter_criteria === void 0 ? void 0 : _nestedFilter_criteria.some(// @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
        FieldFilter.isValid);
        const hasValidNestedFilters = (_ref = (_nestedFilter_nestedFilter = nestedFilter.nestedFilter) === null || _nestedFilter_nestedFilter === void 0 ? void 0 : _nestedFilter_nestedFilter.some((subNested)=>{
            var // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
            _subNested_criteria;
            return subNested === null || subNested === void 0 ? void 0 : (_subNested_criteria = subNested.criteria) === null || _subNested_criteria === void 0 ? void 0 : _subNested_criteria.some(FieldFilter.isValid);
        })) !== null && _ref !== void 0 ? _ref : false;
        return hasValidCriteria || hasValidNestedFilters;
    })) !== null && _ref !== void 0 ? _ref : [];
    const finalNestedFilters = nonEmptyNestedFilters.length > 0 ? nonEmptyNestedFilters.map(to_filter) : [];
    return {
        nativeFields,
        customFields: (_filter_criteria2 = filter.criteria) === null || _filter_criteria2 === void 0 ? void 0 : (_filter_criteria_filter2 = _filter_criteria2.filter(FieldFilter.isValid)) === null || _filter_criteria_filter2 === void 0 ? void 0 : (_filter_criteria_filter_filter1 = _filter_criteria_filter2.filter((x)=>x.field.userCreated)) === null || _filter_criteria_filter_filter1 === void 0 ? void 0 : _filter_criteria_filter_filter1.map(ApiFilter.toCustomFieldFilterFormat),
        match: filter.type,
        nestedFilter: finalNestedFilters
    };
};
const tryParseNativeFieldFilter = (filter, lookup)=>{
    const field = lookup[filter.name];
    try {
        return field ? ApiFilter.parse(filter, field) : null;
    } catch (error) {
        logger.error('failed to parse criteria', {
            filter,
            error: error
        });
        return null;
    }
};
const tryParseCustomFieldFilter = (filter, lookup)=>{
    const byIdLookup = keyBy(Object.values(lookup), 'fieldId');
    const field = byIdLookup[filter.fieldId];
    try {
        const result = field ? ApiFilter.parse(filter, field) : null;
        return result;
    } catch (error) {
        logger.error('failed to parse criteria', {
            filter,
            error: error
        });
        return null;
    }
};
export const from_filter = (lookup)=>(query)=>{
        var _query_match;
        if (Object.keys(lookup).length === 0) {
            return DEFAULT_FILTER;
        }
        const result = {
            type: (_query_match = query.match) !== null && _query_match !== void 0 ? _query_match : QueryCombinerType.All,
            criteria: [],
            nestedFilter: []
        };
        if (query.nativeFields) {
            const nativeFieldFilters = query.nativeFields.map((filter)=>tryParseNativeFieldFilter(filter, lookup)).filter((x)=>x !== null).map((x)=>({
                    ...x,
                    id: uuid()
                }));
            // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
            result.criteria.push(...nativeFieldFilters);
        }
        if (query.customFields) {
            const customFieldFilters = query.customFields.map((filter)=>tryParseCustomFieldFilter(filter, lookup)).filter((x)=>x !== null).map((x)=>({
                    ...x,
                    id: uuid()
                }));
            // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
            result.criteria.push(...customFieldFilters);
        }
        if (query.nestedFilter) {
            result.nestedFilter = query.nestedFilter.map((nestedQuery)=>from_filter(lookup)(nestedQuery));
        }
        return result;
    };
export const from_filter_v2 = (lookup)=>(query)=>{
        var _query_match;
        if (Object.keys(lookup).length === 0) {
            return DEFAULT_FILTER;
        }
        const result = {
            type: (_query_match = query.match) !== null && _query_match !== void 0 ? _query_match : QueryCombinerType.All,
            criteria: [],
            nestedFilter: []
        };
        if (query.nativeFields) {
            const nativeFieldFilters = query.nativeFields.map((filter)=>tryParseNativeFieldFilter(filter, lookup)).filter((x)=>x !== null);
            // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
            result.criteria.push(...nativeFieldFilters);
        }
        if (query.customFields) {
            const customFieldFilters = query.customFields.map((filter)=>tryParseCustomFieldFilter(filter, lookup)).filter((x)=>x !== null);
            // @ts-expect-error TODO: Temporarily expecting error to enable tsc check, Please fix the type error
            result.criteria.push(...customFieldFilters);
        }
        if (query.nestedFilter) {
            result.nestedFilter = query.nestedFilter.map((nestedQuery)=>from_filter_v2(lookup)(nestedQuery));
        }
        return result;
    };
export const getApiFilterTransformer = (lookup)=>({
        from: (simpleSearchFilter)=>from_filter(lookup)(simpleSearchFilter),
        to: to_filter
    });
